// IMPORTANT: Gatsbyのライフサイクルか何かの原因で@エイリアスが効かないので、ここの記法はWarningを無視する
import { isLocaleValid } from "../constants/locales";
import { images, videos } from "../constants/mediaPath";

// 再帰的にオブジェクトからパスを取得する関数
function getNestedValue(obj: any, keys: string[]): any {
  return keys.reduce(
    (o, k) => (o && o[k] !== undefined ? o[k] : undefined),
    obj
  );
}

export const getMediaPath = ({
  path, // 'common.bgPattern01' などのドット区切りのパスを想定
  locale = "en",
  type = "image",
}: {
  path: string;
  locale?: string;
  type?: "image" | "video";
}) => {
  // もしpathが / または https:// から始まる場合、そのまま返す
  if (path.startsWith("/") || path.startsWith("http")) {
    return path;
  }

  // localeが正しいlocaleじゃない場合、そのまま返す
  if (!isLocaleValid(locale)) {
    return path;
  }

  const pathKeys = path.split("."); // 'common.bgPattern01' を ['common', 'bgPattern01'] に分割
  let mediaFiles: typeof images | typeof videos = images;

  if (type === "video") {
    mediaFiles = videos;
  }

  // // localeが存在し、かつそのlocaleの中にpathが存在するかをチェック
  const localizedValue = getNestedValue(mediaFiles["en"], pathKeys);
  if (localizedValue) {
    return localizedValue;
  } else {
    return getNestedValue(mediaFiles["en"], pathKeys); // デフォルトは'en'のパスを表示
  }
};
